// Constants for Specialized Inventory (Phase 4)

export const ADJUSTMENT_TYPES = [
  { value: "found", label: "Found", direction: "+" },
  { value: "count_correction", label: "Count Correction", direction: "set" },
  { value: "lost", label: "Lost", direction: "-" },
  { value: "damaged", label: "Damaged", direction: "-" },
  { value: "scrap", label: "Scrap", direction: "-" },
  { value: "vendor_return", label: "Vendor Return", direction: "-" },
  { value: "warranty_return", label: "Warranty Return", direction: "-" },
  { value: "other", label: "Other", direction: "set" },
];

export const ADJUSTMENT_TYPE_MAP = Object.fromEntries(ADJUSTMENT_TYPES.map((a) => [a.value, a]));

export const SALVAGE_CONDITIONS = ["Excellent", "Good", "Fair", "Poor", "For Parts"];
export const TIRE_CONDITIONS = ["New", "Recap", "Used - Good", "Used - Fair", "Casing"];
export const TIRE_POSITIONS = [
  "Steer - Left", "Steer - Right",
  "Drive - Left Outer", "Drive - Left Inner", "Drive - Right Inner", "Drive - Right Outer",
  "Trailer - LF", "Trailer - RF", "Trailer - LR", "Trailer - RR",
  "Spare", "Other",
];
export const VALUE_TYPES_SIMPLE = [
  { value: "estimated", label: "Estimated" },
  { value: "verified", label: "Verified" },
];
